import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../config/supabase';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../ui/button';
import { IconWithBackground } from '../ui/IconWithBackground';
import { FeatherRabbit } from '../ui/icons';
import rabbitSideImage from '../../images/rabbit-side.png';
import bunnyStepsLogo from '../../images/bunny-steps-logo.png';
import './Login.css';

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    // Check if there's a message in the location state
    if (location.state?.message) {
      setError(location.state.message);
    }
  }, [location]);

  const handleGoogleLogin = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/auth/callback`
        }
      });

      if (error) throw error;

      if (data?.user) {
        const userData = {
          id: data.user.id,
          email: data.user.email,
          displayName: data.user.user_metadata.full_name,
          photoURL: data.user.user_metadata.avatar_url
        };
        
        login(userData);
        
        // Redirect to the page they tried to visit or dashboard
        const redirectTo = location.state?.from || '/dashboard';
        navigate(redirectTo, { replace: true });
      }
    } catch (error) {
      console.error('Login failed:', error.message);
      setError('Failed to sign in with Google. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      {/* Left Image Panel */}
      <div className="login-image-panel">
        <img
          className="login-image"
          src={rabbitSideImage}
          alt="Rabbit illustration"
        />
      </div>

      {/* Right Login Panel */}
      <div className="login-content-panel">
        <div className="login-header">
          <img
            src={bunnyStepsLogo}
            alt="Bunny Steps"
            className="login-logo"
          />
          <p className="login-subtitle">Sign in to continue to your account</p>
        </div>
        <div className="login-form">
          <Button 
            className="h-10 w-full" 
            size="large" 
            onClick={handleGoogleLogin}
            disabled={isLoading}
          >
            {isLoading ? 'Signing in...' : 'Sign in with Google'}
          </Button>
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login; 